function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useState } from 'react';
/**
 * A hook that provides undo/redo functionality for a state value.
 * @param initialState The initial state value.
 * @param limit The maximum number of states to keep in the undo/redo history.
 * @returns An object containing the current state, functions to update the state,
 *          and flags indicating whether undo/redo actions are possible.
 */
export function useUndoRedo(initialState) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var _useState = useState({
      state: initialState,
      undoStack: [],
      redoStack: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var set = useCallback(newState => {
    setValue(prevValue => {
      var undoStack = prevValue.undoStack,
        state = prevValue.state;
      if (newState === state) {
        return prevValue;
      }
      undoStack.push(state);
      if (undoStack.length > limit) {
        undoStack.shift();
      }
      return {
        state: newState,
        undoStack,
        redoStack: []
      };
    });
  }, [limit]);
  var undo = useCallback(() => {
    setValue(prevValue => {
      if (prevValue.undoStack.length === 0) {
        return prevValue;
      }
      var undoStack = prevValue.undoStack,
        redoStack = prevValue.redoStack,
        state = prevValue.state;
      var newValue = undoStack.pop();
      redoStack.push(state);
      return {
        state: newValue,
        undoStack,
        redoStack
      };
    });
  }, []);
  var redo = useCallback(() => {
    setValue(prevValue => {
      if (prevValue.redoStack.length === 0) {
        return prevValue;
      }
      var undoStack = prevValue.undoStack,
        redoStack = prevValue.redoStack,
        state = prevValue.state;
      var newValue = redoStack.pop();
      undoStack.push(state);
      return {
        state: newValue,
        undoStack,
        redoStack
      };
    });
  }, []);
  var clear = useCallback(() => {
    setValue(prevValue => _objectSpread(_objectSpread({}, prevValue), {}, {
      undoStack: [],
      redoStack: []
    }));
  }, []);
  return {
    state: value.state,
    set,
    undo,
    redo,
    canUndo: value.undoStack.length > 0,
    canRedo: value.redoStack.length > 0,
    clear
  };
}
export default useUndoRedo;
//# sourceMappingURL=useUndoRedo.js.map